import React from 'react';
import { toast } from 'react-toastify';

import ImportDataForm from 'components/ImportData';
import { defaultImportFields } from 'components/ImportData/data/fields';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';

const ImportContactsToBroadcastListModalHandler = ({
  isOpen,
  setIsOpen,
  recordTypeId,
  importToBroadcastListService,
  broadcastListId,
  callback
}) => {
  const { getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.CONTACT,
    recordTypeId
  );

  const handleImportSuccess = (response) => {
    if (response?.data?.data?.inBackground) {
      toast.success(
        'A importação dos contatos está sendo feita em segundo plano. Acompanhe pela barra de progressão de importação ou pelo botão "informações".',
        { autoClose: 5000, closeOnClick: true }
      );
      setIsOpen(false);
      if (callback) callback();
      return;
    }

    const { existingContacts, createdContacts } = response?.data?.data;
    const existingTotal = existingContacts.length;
    const createdTotal = createdContacts.length;
    const total = existingTotal + createdTotal;

    toast.success(
      `${total} contato(s) importado(s). ${existingTotal} contato(s) já existente(s) e ${createdTotal} contato(s) criado(s)`
    );

    if (callback) callback();
  };

  return (
    <ImportDataForm
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      recordTypeId={recordTypeId}
      importService={importToBroadcastListService}
      defaultFields={defaultImportFields.BROADCAST_LIST}
      maxRecords={50000}
      type="broadcastList"
      broadcastListId={broadcastListId}
      onImportSuccess={handleImportSuccess}
      getCustomFields={getCustomFields}
    />
  );
};

export default ImportContactsToBroadcastListModalHandler;
